var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleLoginIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.66,
    height: 22.132,
    viewBox: "0 0 21.66 22.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color-",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M4.747,18.507a6.545,6.545,0,0,1,.332-2.054L1.35,13.6a11.141,11.141,0,0,0,0,9.8l3.728-2.854a6.547,6.547,0,0,1-.329-2.045",
    transform: "translate(-0.214 -7.44)",
    fill: "#fbbc05",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-2",
    d: "M12.569,5.06a6.412,6.412,0,0,1,4.08,1.459L19.873,3.3A11.075,11.075,0,0,0,2.623,6.7l3.73,2.848A6.531,6.531,0,0,1,12.569,5.06",
    transform: "translate(-1.487 -0.533)",
    fill: "#eb4335",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-3",
    d: "M12.569,32.841a6.531,6.531,0,0,1-6.216-4.485L2.623,31.2a11.049,11.049,0,0,0,9.945,6.164,10.561,10.561,0,0,0,7.22-2.758l-3.54-2.737a6.855,6.855,0,0,1-3.68.968",
    transform: "translate(-1.487 -15.236)",
    fill: "#34a853",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M34.292,21.745a9.17,9.17,0,0,0-.252-2.012H23.714v4.276h5.944a4.984,4.984,0,0,1-2.264,3.308l3.54,2.737a11.006,11.006,0,0,0,3.358-8.308",
    transform: "translate(-12.632 -10.679)",
    fill: "#4285f4",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLoginIcon);
export default __webpack_public_path__ + "static/media/google-login-icon.4346349e4c9a7eb032c6e66925a08fcd.svg";
export { ForwardRef as ReactComponent };